import Joi from '@hapi/joi';
import useForm from "../../sharedComponents/useForm/useForm";

const initialState = {
  email: '',
  password: ''
};

const reducer = (state, action) => {
  return {
    ...state,
    [action.field] : action.value
  };
};

const schema = Joi.object({
  email: Joi.string().email({ tlds: {allow: false} }).label('Email').required(),
  password: Joi.string().min(3).label('Password').required()
});

const useLoginForm = () => {
  const { form, validate } = useForm(reducer, initialState, schema);

  return {
    ...form,
    validate
  };
};

export default useLoginForm;